import { useEffect, useReducer, useRef } from 'react';
import { useDIContainer } from '@/container/RouteContainerProvider';
import { GovernanceIssueStore } from './GovernanceIssueStore';

/**
 * Resolves the singleton {@link GovernanceIssueStore} and subscribes the calling
 * component to its changes. Mirrors {@link usePinnedTilesStore} — deliberately NOT
 * {@link useViewModel}, whose unmount `dispose()` (doubled by StrictMode) would tear
 * down a shared singleton's subscription and stop live updates.
 */
export function useGovernanceIssueStore(): GovernanceIssueStore {
    const container = useDIContainer();
    const ref = useRef<GovernanceIssueStore | null>(null);
    if (ref.current === null) {
        ref.current = container.resolve(GovernanceIssueStore);
    }
    const store = ref.current;
    const [, forceUpdate] = useReducer((count: number) => count + 1, 0);
    useEffect(() => store.subscribe(() => forceUpdate()), [store]);
    return store;
}
